import { Dispatch, SetStateAction } from 'react';
import { CampaignData, Mission, Stats, Losses, KillEvents, UploadUserData, LocalUserData, CampaignPostData } from '../Interfaces/Interfaces';



export default class Data  {

	private target: string;
	private localData:LocalUserData = JSON.parse(localStorage.getItem("user") as string);

	constructor(target: string) {
		this.target = target;
	};

	GET = async (setter: SetStateAction<Dispatch<any
		//null |
		//Required<CampaignData> |
		//Array<Required<Omit<CampaignData,"missions">>> |
		//MissionDetails |
		//Array<Required<Mission>> 
	>>) => {
		try {
			const request = await fetch(process.env.REACT_APP_URL + this.target);
			const response = await request.json();
			/*
			 * HOTFIX
			 * START
			*/
			const targetSplitter = this.target.split('/');

			switch (targetSplitter[0].toLocaleLowerCase()) {
				case 'missions':
					response.forEach((element: Required<Mission>, index: number) => {
						element.createdDate = new Date(element.createdDate).toLocaleDateString();
						element.hash = element.hash.split('@')[1];	 //needs to be called instance
					});
					break;

				case 'campaigns':
					response.forEach((element: Required<Omit<CampaignData,"missions">>, index: number) => {
						element.createdDate = new Date(element.createdDate).toLocaleDateString();
					});
					break;

				case 'missiondetails':
					response.time = new Date(response.createdDate).toLocaleTimeString();
					response.createdDate = new Date(response.createdDate).toLocaleDateString();
					response.stats.forEach((element: Stats) => {
						element.id = element.playerid
						element.killsGround =
							element.killsArmor +
							element.killsInfantry +
							element.killsFortification +
							element.killsOther +
							element.killsAirDefense +
							element.killsArtillery +
							element.killsUnarmed;
					});
					response.losses.redDetails.forEach((element: Losses, index: number) => element.id = index);
					response.losses.blueDetails.forEach((element: Losses, index: number) => element.id = index);
					response.killEvents.forEach((element: Required<Omit<KillEvents,"name">>, index: number) => {
						element.id = index;
						element.createdDate = new Date(element.createdDate).toLocaleTimeString();
					});
					break;

				case 'campaigndetails':
					response.createdDate = new Date(response.createdDate).toLocaleDateString();
					(response as CampaignData).missions.forEach((element: Required<Mission>, index: number) => {
						element.createdDate = new Date(element.createdDate).toLocaleDateString();
						element.hash = element.hash.split('@')[1];	 //needs to be called instance
					});
					break;
			}	
			/*
			 *  HOTFIX
			 *	END
			 */
		setter(response);
		} catch (error) {
			console.log(error);
		}
	};

	POST = async (payload: UploadUserData | CampaignPostData): Promise<boolean> => {
		const request = await fetch(process.env.REACT_APP_URL + this.target, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${this.localData?.token}`
			},
			body: JSON.stringify(payload)
		});
		const response = await request.json();
		//console.log(this.target)
		if (request.ok && this.target.toLowerCase() === 'users/login') {
			localStorage.setItem('user', JSON.stringify(response));
			return true
		}
			return false

		//console.log(response);

	};

	PUT = async (payload: any) => {
		console.log()
		/*
		 * TO BE TESTED
		 * 
		const request = await fetch(process.env.REACT_APP_URL + this.target, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload);
		});
		const response = await request.json();
		console.log(response);
		*/
	};

	DELETE = async (idArray:Array<number>) => {
		console.log(`delete request has been made of type ${this.target} and the payload is ${idArray}`)
		const request = await fetch(process.env.REACT_APP_URL + this.target, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${this.localData.token}`
			},
			body: JSON.stringify(idArray)
		});
		const response = await request.json();
		console.log(response)
	};
}